var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.012 131.381V115.596C159.913 115.596 157.343 113.1 157.343 110.09V91.2949C157.343 88.7914 155.302 86.8164 152.733 86.8164H100.81C84.4854 86.8164 71.1836 99.7305 71.1836 115.596V134.603C71.1836 136.08 71.7882 137.475 72.8464 138.502C73.9044 139.523 75.3404 140.11 76.852 140.11C82.596 140.11 86.9795 144.074 86.9795 149.287C86.9795 154.727 82.5204 159.059 76.9276 159.125C73.8288 159.125 71.1836 161.254 71.1836 164.338V183.14C71.1836 198.998 84.4854 211.846 100.735 211.846H152.733C155.302 211.846 157.343 209.856 157.343 207.368V191.502C157.343 188.426 159.913 185.996 163.012 185.996V171.761C159.913 171.761 157.343 169.257 157.343 166.254V136.887C157.343 133.877 159.913 131.381 163.012 131.381Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.684 149.29C211.684 154.723 216.219 159.055 221.736 159.128C224.835 159.128 227.48 161.258 227.48 164.267V183.136C227.48 199.001 214.253 211.85 197.929 211.85H173.291C170.796 211.85 168.68 209.86 168.68 207.364V191.505C168.68 188.422 166.186 185.999 163.012 185.999V171.763C166.186 171.763 168.68 169.26 168.68 166.257V136.891C168.68 133.873 166.186 131.384 163.012 131.384V115.592C166.186 115.592 168.68 113.096 168.68 110.086V91.2983C168.68 88.7948 170.796 86.8125 173.291 86.8125H197.929C214.253 86.8125 227.48 99.6605 227.48 115.519V134.019C227.48 135.488 226.875 136.891 225.817 137.911C224.759 138.939 223.323 139.526 221.812 139.526C216.219 139.526 211.684 143.939 211.684 149.29Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponEmpty);
export default __webpack_public_path__ + "static/media/couponEmpty.240a838ec3c9b6e8232d8641cefe0ab5.svg";
export { ForwardRef as ReactComponent };